import { Image, Space, Typography } from 'antd';

interface Props {
    proofOfDelivery?: string;
    proofOfDeliveryCode?: string;
}

const { Title } = Typography;

const ProofOfDelivery = ({
    proofOfDelivery,
    proofOfDeliveryCode,
}: Props) => (
    <Space direction="vertical" size={12}>
        {
            proofOfDeliveryCode && (
                <Title level={4} style={{ textAlign: 'center' }}>
                    {`# ${proofOfDeliveryCode}`}
                </Title>
            )
        }
        {
            proofOfDelivery && (
                <Image
                    src={proofOfDelivery}
                    alt="Proof of Delivery"
                    width={200}
                    height={200}
                    preview={false}
                />
            )
        }
    </Space>
);

export { ProofOfDelivery };
